(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zapp-ugc-wall"] && !Shopify.designMode) return;
  try {
    
  class ZappUgcWall {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('[data-zapp-ugcw-track]');
      this.pills = Array.from(root.querySelectorAll('[data-zapp-ugcw-filter]'));
      this.items = Array.from(root.querySelectorAll('[data-zapp-ugcw-item]'));

      this.pills.forEach((pill) => {
        pill.addEventListener('click', () => this.filter(pill));
      });

      const prev = root.querySelector('[data-zapp-ugcw-prev]');
      const next = root.querySelector('[data-zapp-ugcw-next]');
      if (prev) prev.addEventListener('click', () => this.scrollBy(-1));
      if (next) next.addEventListener('click', () => this.scrollBy(1));
    }

    filter(pill) {
      const target = pill.getAttribute('data-zapp-ugcw-filter');

      this.pills.forEach((p) => {
        const active = p === pill;
        p.classList.toggle('is-active', active);
        p.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      this.items.forEach((item) => {
        const category = item.getAttribute('data-category') || '';
        const show = target === 'all' || category === target;
        item.hidden = !show;

        // Stop any video that just got filtered out.
        if (!show) {
          const video = item.querySelector('video');
          if (video && !video.paused) video.pause();
        }
      });

      if (this.track) this.track.scrollTo({ left: 0 });
    }

    scrollBy(direction) {
      if (!this.track) return;
      const card = this.track.querySelector('.zapp-ugcw__card:not([hidden])');
      const step = card ? card.getBoundingClientRect().width + 12 : 220;
      this.track.scrollBy({ left: step * 2 * direction, behavior: 'smooth' });
    }
  }

  function initZappUgcWalls(scope) {
    (scope || document).querySelectorAll('[data-zapp-ugcw]').forEach((root) => {
      if (root.dataset.zappUgcwReady === 'true') return;
      root.dataset.zappUgcwReady = 'true';
      new ZappUgcWall(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initZappUgcWalls());
  } else {
    initZappUgcWalls();
  }

  // Theme editor re-renders sections in place.
  document.addEventListener('shopify:section:load', (event) => initZappUgcWalls(event.target));

  } catch(e) { console.error(e); }
})();
})();
